import { fetchGraphQL } from './fetchGraphQL';
import { LegalContentQuery } from './generators/LegalContentQuery';
import { ContentCollectionQuery } from './generators/ContentCollectionQuery';
import { BannerQuery } from './generators/BannerQuery';
import { PageMetaQuery } from './generators/PageMetaQuery';

// NOTE: Potential to start hitting rate limits with this query as we'll be at least 4x the query count
export async function fetchPageContent(url: string, isPreview: boolean) {
  // Execute all GraphQL queries in parallel for better performance
  const [{ data }, legalData, contentData, bannerData] = await Promise.all([
    fetchGraphQL(PageMetaQuery(url), isPreview),
    fetchGraphQL(LegalContentQuery(url), isPreview),
    fetchGraphQL(ContentCollectionQuery(url), isPreview),
    fetchGraphQL(BannerQuery(url), isPreview),
  ]);

  // Add legal data if it exists
  if (legalData?.data?.pageCollection?.items?.[0]?.legal) {
    data.pageCollection.items[0].legal = legalData.data.pageCollection.items[0].legal;
  } else {
    // If legal data does not exist, set it to null
    data.pageCollection.items[0].legal = null;
  }

  // Add content collection if it exists
  if (contentData?.data?.pageCollection?.items?.[0]?.contentCollection) {
    data.pageCollection.items[0].contentCollection = contentData.data.pageCollection.items[0].contentCollection;
  }

  // Add banner data if it exists and is not null
  const bannerItem = bannerData?.data?.pageCollection?.items?.[0]?.banner;
  if (bannerItem !== null && bannerItem !== undefined) {
    data.pageCollection.items[0].banner = bannerItem;
  } else {
    data.pageCollection.items[0].banner = null;
  }

  return { data };
}
